(function () {
    const initAllSliders = function () {
        const galleryWrapper = document.querySelector('.JS-nemovitosti-foto'),
            slidesCount = getComputedStyle(galleryWrapper).getPropertyValue('--estateImages-slidesCount'),
            slidesSpacing = getComputedStyle(galleryWrapper).getPropertyValue('--estateImages-slidesSpacing');

        const parsedSlidesCount = slidesCount ? Math.floor(parseFloat(slidesCount)) : 3.5;
        const parsedSlidesSpacing = slidesSpacing ? parseInt(slidesSpacing) : 10;

        const swiperTop = document.querySelectorAll('.JS-swiper-nemovitosti-foto-main');

        const observerTop = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const estateList = el.closest('.js-estateList');
                    // Inicializovat pouze pokud není ve výpisu, nebo pokud je ve výpisu aktivní grid (zobrazení karet)
                    if (!estateList || estateList.getAttribute('data-layout') !== 'rows') {
                        if (window.requestIdleCallback) {
                            requestIdleCallback(() => initSwiperTop(el));
                        } else {
                            setTimeout(() => initSwiperTop(el), 10);
                        }
                        observerTop.unobserve(el);
                        el.setAttribute('data-swiper-custom-init', 'true');
                    }
                }
            });
        }, { rootMargin: "500px" });

        swiperTop.forEach(el => observerTop.observe(el));

        function initSwiperTop(el) {
            const realSlidesTop = el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
            const loopEnabled = realSlidesTop > 1;
            const swiperBottom = el.nextElementSibling;
            let galleryThumbs = null;

            if (swiperBottom) {
                const realSlidesThumbs = swiperBottom.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
                const thumbsLoopEnabled = realSlidesThumbs > 1;

                const galleryThumbs = new Swiper(swiperBottom, {
                    spaceBetween: parsedSlidesSpacing,
                    slidesPerView: parsedSlidesCount,
                    slideToClickedSlide: true,
                    watchSlidesProgress: true,
                    loop: false,
                    lazy: {
                        loadPrevNext: true,
                    },
                    allowTouchMove: thumbsLoopEnabled,
                    freeMode: false,
                    centeredSlides: true,
                    centeredSlidesBounds: true
                });

                if (!thumbsLoopEnabled) swiperBottom.setAttribute('data-single-slide', 'true');


                const galleryTop = new Swiper(el, {
                    navigation: {
                        nextEl: el.nextElementSibling?.querySelector('[data-swiper-next]')
                    },
                    loop: false,
                    lazy: {
                        loadPrevNext: true,
                    },
                    allowTouchMove: loopEnabled,
                    thumbs: {
                        swiper: galleryThumbs,
                    }
                });

                if (!loopEnabled) el.setAttribute('data-single-slide', 'true')

                // Update obou swiperů při změně velikosti
                const observer = new ResizeObserver(() => {
                    galleryTop.update();
                    galleryThumbs.update();
                });
                observer.observe(el);
                observer.observe(swiperBottom);
            }

        }

        const swiperRowsElements = document.querySelectorAll('.JS-swiper-nemovitosti-foto-rows.swiper-container');

        const observerRows = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const estateList = el.closest('.js-estateList');
                    // Inicializovat pouze pokud není ve výpisu, nebo pokud je ve výpisu aktivní zobrazení řádků
                    if (!estateList || estateList.getAttribute('data-layout') === 'rows') {
                        if (window.requestIdleCallback) {
                            requestIdleCallback(() => initSwiperRow(el));
                        } else {
                            setTimeout(() => initSwiperRow(el), 10);
                        }
                        observerRows.unobserve(el);
                        el.setAttribute('data-swiper-custom-init', 'true');
                    }
                }
            });
        }, { rootMargin: "500px" });

        swiperRowsElements.forEach(el => observerRows.observe(el));

        function initSwiperRow(el) {
            const rowSwiper = new Swiper(el, {
                breakpoints: {
                    0: {
                        slidesPerView: 1.5,
                        spaceBetween: 5,
                    },
                    550: {
                        slidesPerView: 2.5,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 2.5,
                        spaceBetween: 20,
                    },
                    1600: {
                        slidesPerView: 3.5,
                        spaceBetween: 30,
                    }
                },
                navigation: {
                    nextEl: el.querySelector('[data-swiper-next]')
                },
                lazy: {
                    loadPrevNext: true,
                }
            });

            const resizeObserver = new ResizeObserver(() => {
                rowSwiper.update();
            });
            resizeObserver.observe(el);

            const mutationObserver = new MutationObserver(mutations => {
                for (const mutation of mutations) {
                    if (mutation.type === 'attributes') {
                        rowSwiper.update();
                    }
                }
            });
            mutationObserver.observe(el, {
                attributes: true,
                childList: false,
                subtree: false
            });
        }

        const estateList = document.querySelector('.estateList.js-estateList');

        if (estateList) {
            const layoutObserver = new MutationObserver(mutations => {
                for (const mutation of mutations) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-layout') {
                        const newLayout = estateList.getAttribute('data-layout');
                        if (newLayout === 'rows' || newLayout === 'grid') {
                            window.dispatchEvent(new Event('resize'));

                            // Force check sliders that might have just become visible
                            if (newLayout === 'grid') {
                                swiperTop.forEach(el => {
                                    if (!el.hasAttribute('data-swiper-custom-init')) {
                                        observerTop.unobserve(el);
                                        observerTop.observe(el);
                                    }
                                });
                            } else if (newLayout === 'rows') {
                                swiperRowsElements.forEach(el => {
                                    if (!el.hasAttribute('data-swiper-custom-init')) {
                                        observerRows.unobserve(el);
                                        observerRows.observe(el);
                                    }
                                });
                            }
                        }
                    }
                }
            });

            layoutObserver.observe(estateList, {
                attributes: true,
                attributeFilter: ['data-layout']
            });
        }
    };

    const filterApp = document.querySelector('[data-frontend-filter]');
    let initialized = false;

    const start = function() {
        if (initialized) return;
        initialized = true;
        initAllSliders();
    };

    if (filterApp) {
        // Vue loaded signal from main.ts
        filterApp.addEventListener('VueLoaded', start);
        // Fallback for case it was already loaded or something failed
        setTimeout(start, 2000);
    } else {
        start();
    }
})();
